import { useNavigate } from "react-router-dom";
import { UserCog, Undo2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ImpersonationBanner() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;
  const stop = async () => {
    try { const { data } = await api.post("/admin/impersonate/stop"); setUser(data); toast.success("Sei tornato amministratore"); navigate("/admin?tab=registrazioni"); }
    catch (e) { toast.error(e.response?.data?.detail || "Impossibile ripristinare la sessione admin"); }
  };
  return (
    <div className="sticky top-0 z-[60] bg-[#C2593F] text-white text-sm px-4 py-2 flex items-center justify-between gap-3" data-testid="impersonation-banner">
      <span className="inline-flex items-center gap-2 min-w-0"><UserCog className="w-4 h-4 shrink-0" /><span className="truncate">Stai operando come <b>{user.name}</b> ({user.email})</span></span>
      <button onClick={stop} className="shrink-0 inline-flex items-center gap-1 bg-white text-[#C2593F] font-semibold rounded-full px-3 py-1 text-xs hover:bg-[#FEF9C3]" data-testid="impersonation-stop">
        <Undo2 className="w-3.5 h-3.5" />Torna admin
      </button>
    </div>
  );
}
